import React from 'react'

/**
 * Tile placeholder
 * @param {Object} props - The props
 * @param {String} props.display - The display type
 * @returns {JSX.Element} The tile placeholder
 */
function TileV2Placeholder (props) {
  const { display } = props

  return (
    <div className="tile-v2__placeholder-wrapper">
      <div className={`tile-v2 tile-v2--placeholder tile-v2--placeholder-${display}`} />
      <span className="tile-v2__placeholder-line" />
      <span className="tile-v2__placeholder-line tile-v2__placeholder-line--short" />
    </div>
  )
}

export default TileV2Placeholder
